import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WorkspaceService } from '../services/workspace/workspace.service';
import { WorkspaceRole } from '../models/workspace.model';
import { UserAuthenticationService } from '../services/user-authentication/user-authentication.service';

// The goal of this guard is to validate if an authenticated user respects a certain role policy
export const RoleGuard: CanActivateFn = async (route) => {
	const router = inject(Router)
	const workspaceService = inject(WorkspaceService);
	const userAuthenticationService = inject(UserAuthenticationService);

	// 1. Validate if user is authenticated
	// If user is not authenticated we let it proceed 
	// Why? For reasons I can't understand certain page navigations are available for unauthenticated users but are not available for authenticated users with a specific role
	let isAuthenticated = await userAuthenticationService.verifyIfUserIsAuthenticatedAsync();
	while(isAuthenticated === undefined){
		await new Promise(resolve => setTimeout(resolve, 500));
		isAuthenticated = await userAuthenticationService.verifyIfUserIsAuthenticatedAsync();
	}
	if(!isAuthenticated){ return true; }

	let currentWorkspace = workspaceService.getCurrentUserWorkspace();

	while (currentWorkspace === undefined) {
		await new Promise(resolve => setTimeout(resolve, 500));
		currentWorkspace = workspaceService.getCurrentUserWorkspace();
	}

	if (currentWorkspace) {
		if (workspaceService.inCurrentWorkspaceIsOwner() || workspaceService.inCurrentWorkspaceIsAdmin()) {
			return true;
		}

		// Get the roles from the route data
		const roles: WorkspaceRole[] = route.data['roles'];

		if (roles && !roles.map(role => role.toLowerCase()).includes(currentWorkspace.role.toLowerCase())) {
			const outletsConfig: { modal: string, primary?: string } = { modal: "no-permissions" }
			if(router.lastSuccessfulNavigation() === null){
				outletsConfig.primary = "home"
			}
			router.navigate([{ outlets: outletsConfig }], { skipLocationChange: true })
			return false;
		}
	}
	return true;
};
